import { Select, MenuItem, makeStyles, InputLabel } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  icon: {
    fill: '#000000',
  },
  label: {
    color: '#9e9e9e',
  },
  selectMenu: {
    fontWeight: '600',
    marginTop: '0.4rem',
    paddingBottom: '0.4rem',
    width: '87%',
    '&:before': {
      borderColor: '#9e9e9e ',
    },
    '&:after': {
      borderColor: '#009688',
    },
  },
  menuItem: {
    color: '#009688',
  },
}));

const DropdownMenu = ({ items, itemName, itemValue, name, placeHolder, onChangeHandler, isItemsAnArray, value }) => {
  const classes = useStyles();

  const handleChange = (e) => {
    onChangeHandler(e.target.value);
  };

  return (
    <>
      <InputLabel className={classes.label} id={`${name}-label`}>
        {name}
      </InputLabel>
      <Select className={classes.selectMenu} inputProps={{ classes: { icon: classes.icon } }} labelId={`${name}-label`} id={name} value={value} onChange={handleChange} label={name}>
        {placeHolder && (
          <MenuItem className={classes.menuItem} value={placeHolder}>
            {placeHolder}
          </MenuItem>
        )}
        {isItemsAnArray
          ? items.map((item) => (
              <MenuItem className={classes.menuItem} key={item[`${itemValue}`]} value={item[`${itemValue}`]}>
                {item[`${itemName}`]}
              </MenuItem>
            ))
          : Object.entries(items).map(([key, value]) => (
              <MenuItem className={classes.menuItem} key={key} value={value}>
                {value}
              </MenuItem>
            ))}
      </Select>
    </>
  );
};

export default DropdownMenu;
